import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import { COLUMNS_COUNT } from '../constants';

const COL_TOKEN_PATTERN = /^((?:[\w-]+:)*)col-\[([^\]]+)\]$/;
const COL_PERCENTAGE_TOKEN_PATTERN = /^((?:[\w-]+:)*)col-\[([\d.]+)%\]$/;

const FRACTION_BY_PERCENTAGE = new Map(
  Array.from({ length: COLUMNS_COUNT }, (_, index) => {
    const numerator = index + 1;
    return [parseFloat(((numerator / COLUMNS_COUNT) * 100).toFixed(5)), numerator];
  })
);

const buildColFractionClass = (prefix, numerator) => `${prefix}col-[${numerator}/${COLUMNS_COUNT}]`;

const findColToken = (tokens, breakpointPrefix) =>
  tokens.find((token) => {
    const match = token.match(COL_TOKEN_PATTERN);
    return Boolean(match) && match[1] === `${breakpointPrefix}:`;
  });

const getConvertibleBreakpoints = (tokens, breakpoints) => {
  const convertible = [];

  const canConvertAll = breakpoints.every((candidateBreakpoint) => {
    const token = findColToken(tokens, candidateBreakpoint);

    if (!token) return true;

    const percentageMatch = token.match(COL_PERCENTAGE_TOKEN_PATTERN);

    if (!percentageMatch) return true;

    const percentageValue = parseFloat(percentageMatch[2]);

    if (!FRACTION_BY_PERCENTAGE.has(percentageValue)) {
      return false;
    }

    convertible.push(candidateBreakpoint);
    return true;
  });

  return canConvertAll ? convertible : [];
};

const convertMatchingTokens = (classAttributeValue, breakpoints) => {
  const tokens = (classAttributeValue || '').split(/\s+/).filter(Boolean);
  const convertibleBreakpoints = getConvertibleBreakpoints(tokens, breakpoints);

  return tokens
    .map((token) => {
      const match = token.match(COL_PERCENTAGE_TOKEN_PATTERN);

      if (!match) return token;

      const [, prefix, percentage] = match;
      const prefixBreakpoint = prefix.slice(0, -1);

      if (!convertibleBreakpoints.includes(prefixBreakpoint)) {
        return token;
      }

      return buildColFractionClass(prefix, FRACTION_BY_PERCENTAGE.get(parseFloat(percentage)));
    })
    .join(' ');
};

const convertNarrowerColPercentagesToFractions = (classAttributeValue, breakpoint) => {
  if (breakpoint === TABLET_BREAKPOINT) {
    return convertMatchingTokens(classAttributeValue, [MOBILE_BREAKPOINT]);
  }

  if (breakpoint === MOBILE_BREAKPOINT) {
    return convertMatchingTokens(classAttributeValue, []);
  }

  return convertMatchingTokens(classAttributeValue, [TABLET_BREAKPOINT, MOBILE_BREAKPOINT]);
};

export default convertNarrowerColPercentagesToFractions;
